import { useQuery } from '@tanstack/react-query'
import { fetchStates } from '@/lib/api'

export const useStates = (countryId: string | undefined) => {
  return useQuery({
    queryKey: ['states', countryId],
    queryFn: () => fetchStates(countryId!),
    enabled: !!countryId,
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false
  })
}
